import { render, staticRenderFns } from "./AdvCartButton.vue?vue&type=template&id=2c4771f7"
import script from "./AdvCartButton.vue?vue&type=script&lang=js"
export * from "./AdvCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports